// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__56Y8t","row":"Table_row__sSYXo","head":"Table_head__6nBpN","headCell":"Table_headCell__hVxdC","cell":"Table_cell__KR3T1"};